"use strict";

const NunjucksFunctions = function () {
  var setupFunctions = function (env) {
    const functionList = {
      getConstructionActionDropdownOptions,
      getLidActionDropdownOptions,
      getConstructionProjectDeliveryActionDropdownOptions,
      _getConstructionComplianceActionDropdownOptions,
      getFacilityActionDropdownOptions,
      getFacilityHistoryActionDropdownOptions,
      getIncidentActionDropdownOptions,
      getIncidentHistoryActions,
      getIncidentHistoryActionDropdownOptions,
      getActivityActionDropdownOptions,
      getCatchBasinDropdownOptions,
      getStructuralBmpActionDropdownOptions,
      getSbmpHistoryActionDropdownOptions,
      getOutfallHistoryActionDropdownOptions,
      getHardAssetDropdownOptions,
      getOutfallDropdownOptions,
      getHardAssetFactSheetDropdownOptions,
      getHardAssetHistoryActionDropdownOptions,
      getScenarioDropdownOptions,
      getTrashFcsDropdownOptions,
      getPropertyDropdownOptions,
      getPlanDropdownOptions,
      getPlanPropertyDropdownOptions,
      getLidFactSheetDropdownOptions,
      getFactSheetDropdownOptions,
      getBmpDropdownOptions,
      getContactDropdownOptions,
      getProjectUserDropdownOptions,
      getPermitAndPlanDropdownOptions,
      getProjectHistoryDropdownOptions,
      getUserDropdownOptions,
      getDisplayFieldSetting,
      isPhaseOrLater,
      getDeviceSize,
      featureFlagEnabled,
      isAdmin,
      getDisplayFallback,
      getAssetDisplayName,
      getUserPermission,
      getInspectionUrl: InspectionUrl.getForCurrentView,
    };

    // Can't use an array because function names get minimized on production
    for (const fnName in functionList) {
      env.addGlobal(fnName, functionList[fnName]);
    }
  };

  const getConstructionActionDropdownOptions = function (
    dropdownOptions,
    canEditProject,
    canIssueEnforcement,
    canDeleteProject = false,
  ) {
    const currentDataView = Tree.get("dataView");
    const options = [];

    if (canEditProject) {
      options.push({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: dropdownOptions?.find((option) => option.name === "Site Visit") ? false : true,
      });
    }

    options.push(...dropdownOptions);

    if (currentDataView === "lid-project" && canIssueEnforcement) {
      options.push({
        name: "Issue Enforcement",
        analyticsAction: "issue_enforcement",
        iconClass: "glyphicon-issue-enforcement",
        linkClass: "issue-lid-enforcement online-only",
      });
    }

    options.push({
      name: "Go to Map",
      analyticsAction: "go_to_map",
      iconClass: "glyphicon-map-marker",
      linkClass: "map-button online-only",
      primary: canEditProject ? false : true,
    });

    if (FeatureFlag.enabled("download-project-photos")) {
      options.push({
        name: "Download Project Photos",
        analyticsAction: "download_photos",
        iconClass: "glyphicon-download-alt",
        linkClass: "download-button online-only",
      });
    }

    if (canDeleteProject) {
      options.push({
        name: "Delete Project",
        analyticsAction: "delete_project",
        iconClass: "glyphicon-trash",
        linkClass: "delete-button online-only",
      });
    }

    return options;
  };

  const getLidActionDropdownOptions = function (project) {
    const actionableOptions = [];

    _addLidInspectionLetter(project.showGenerateSummaryButton, actionableOptions);

    return actionableOptions;
  };

  const _addLidInspectionLetter = function (showGenerateSummaryButton, actionableOptions) {
    if (showGenerateSummaryButton) {
      actionableOptions.push({
        name: "Generate Inspection Report",
        iconClass: "mail",
        linkClass: "js-inspection-letter online-only",
        primary: true,
      });
    }
  };

  const getConstructionProjectDeliveryActionDropdownOptions = function (
    canAdvanceProjectPhase,
    canCertifyProject,
    projectPhase,
  ) {
    // Can't include at the bottom because it interferes with testing mocks
    const ProjectStageData = require("../construction/projectStageData");
    const enablePostActivePhase = ToolSettings.getSetting(
      "construction",
      "enable-post-active-phase",
    );
    const dropdownOptions = [];
    const isCertifyStage = ProjectStageData.getStageByPhase(projectPhase) === "certified";

    if (!isCertifyStage && canAdvanceProjectPhase) {
      dropdownOptions.unshift({
        name: "Change Phase",
        iconClass: "glyphicon-arrow-right",
        linkClass: "phase-button online-only",
        primary: true,
      });
    }

    if (projectPhase === "completed" && canCertifyProject) {
      dropdownOptions.unshift({
        name: "Certify Project",
        iconClass: "glyphicon-ok",
        linkClass: "certify-button online-only",
        primary: true,
      });
    }

    if (canCertifyProject) {
      if (enablePostActivePhase && projectPhase === "construction") {
        dropdownOptions.unshift({
          name: "Set as Post Active",
          iconClass: "glyphicon-arrow-right",
          linkClass: "post-active-button online-only",
          primary: true,
        });
      } else if (
        (!enablePostActivePhase && projectPhase === "construction") ||
        (enablePostActivePhase && projectPhase === "post-active")
      ) {
        dropdownOptions.unshift({
          name: "Complete Project",
          analyticsAction: "complete_proj",
          iconClass: "glyphicon-ok",
          linkClass: "completed-button online-only",
          primary: true,
        });
      }
    }

    return dropdownOptions;
  };

  const _getConstructionComplianceActionDropdownOptions = function (
    projectId,
    phase,
    pauseStatus,
    canInspectProject,
    canCertifyProject,
    canAdvanceProjectPhase,
    canCreateEnforcement,
  ) {
    const dropdownOptions = [];

    if (canCreateEnforcement) {
      dropdownOptions.unshift({
        name: "Issue Enforcement",
        analyticsAction: "issue_enforcement",
        iconClass: "glyphicon-issue-enforcement",
        linkClass: "issue-project-enforcement online-only",
      });
    }

    if (canInspectProject && projectId) {
      dropdownOptions.unshift({
        primary: true,
        name: "Site Visit",
        analyticsAction: "add_site_visit",
        iconClass: "glyphicon-plus-sign",
        linkClass: "js-add-construction-project-inspection",
        linkAttribute: `data-project-id='${projectId}'`,
      });
    }

    if (canAdvanceProjectPhase && phase === "construction") {
      dropdownOptions.unshift({
        name: pauseStatus === "paused" ? "Restart Inspections" : "Pause Inspections",
        analyticsAction: "pause_project",
        iconClass:
          pauseStatus === "paused" ? "glyphicon glyphicon-play" : "glyphicon glyphicon-pause",
        linkClass: "pause-button online-only",
      });
    }

    const enablePostActivePhase = ToolSettings.getSetting(
      "construction",
      "enable-post-active-phase",
    );
    if (canCertifyProject) {
      if (enablePostActivePhase && phase === "construction") {
        dropdownOptions.unshift({
          name: "Set as Post Active",
          iconClass: "glyphicon-arrow-right",
          linkClass: "post-active-button online-only",
        });
      } else if (
        (!enablePostActivePhase && phase === "construction") ||
        (enablePostActivePhase && phase === "post-active")
      ) {
        dropdownOptions.unshift({
          name: "Complete Project",
          analyticsAction: "complete_proj",
          iconClass: "glyphicon-ok",
          linkClass: "completed-button online-only",
        });
      }
    }

    return dropdownOptions;
  };

  const canEditHardAssetInventory = function (assetType) {
    const HardAssetInventoryModalController = require("../muni/hardAssetInventoryModalController");
    return HardAssetInventoryModalController.canEditInventory(assetType);
  };

  const canInspectHardAsset = function (assetType, groupId) {
    return (
      UserPermissions.getPermission("inspectable_asset_types").includes(assetType) &&
      Progeny.canEditGroup(groupId)
    );
  };

  const getHardAssetDropdownOptions = function (id, groupId, assetType) {
    const canInspect = canInspectHardAsset(assetType, groupId);
    const canEditInventory = canEditHardAssetInventory(assetType);
    const options = [];

    if (canInspect) {
      options.push({
        name: "Inspect",
        analyticsAction: "add_site_visit",
        primary: true,
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView(assetType, id),
        ...(HardAssetInspectionGate.isOfflineEnabledForAssetType(assetType)
          ? {}
          : { linkClass: "online-only" }),
      });
    }

    options.push({
      name: "Go to Map",
      analyticsAction: "go_to_map",
      iconClass: "glyphicon-map-marker",
      linkClass: "map-button online-only",
      primary: !canEditInventory,
    });

    if (canEditInventory) {
      options.push({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only open-hard-asset-inventory",
        linkAttribute: `data-asset-type="${assetType}"`,
        primary: !canInspect,
      });
    }

    return options;
  };

  const getHardAssetFactSheetDropdownOptions = function (
    assetType,
    permissions,
    closeUrl,
    id,
    canCreateRoutineInspection,
  ) {
    const dropdownOptions = [];

    if (canCreateRoutineInspection) {
      dropdownOptions.push({
        name: "Inspect",
        analyticsAction: "add_site_visit",
        primary: true,
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView(assetType, id),
      });
    }

    if (Tree.get("dataView") === "dry-weather") {
      if (UserRoles.getRolePermissionForUser("canCreateDryWeatherScreenings")) {
        dropdownOptions.unshift({
          name: "Dry Weather Screening",
          analyticsAction: "dry_weather_screening",
          iconClass: "glyphicon-plus-sign",
          linkClass: "open-dry-weather-screening",
          linkAttribute: `data-asset-type="${assetType}"`,
        });
      }
    } else {
      dropdownOptions.unshift({
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only fact-sheet-go-to-map",
        linkAttribute: `data-close-url="${closeUrl}"`,
        primary: !permissions.canEdit,
      });
    }

    if (canEditHardAssetInventory(assetType)) {
      dropdownOptions.push({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only open-hard-asset-inventory",
      });
    }

    if (permissions.user_role === "admin" || permissions.user_role === "data-manager") {
      dropdownOptions.push({
        name: "Delete Asset",
        analyticsAction: "delete_asset",
        iconClass: "glyphicon-trash",
        linkClass: "delete-button online-only hard-asset-delete-button",
        linkAttribute: `data-asset-type="${assetType}"`,
      });
    }

    return dropdownOptions;
  };

  const getHardAssetHistoryActionDropdownOptions = function (historyItem) {
    const options = [];

    if (historyItem.canCreateRoutineInspection) {
      options.push({
        name: "Edit",
        iconClass: "glyphicon glyphicon-pencil",
        linkClass: "js-edit-assessment",
        primary: !historyItem.hasReport,
      });
    }

    if (historyItem.hasReport) {
      options.push({
        name: "Download assessment report",
        iconClass: "glyphicon glyphicon-download-alt",
        linkClass: "download-report",
        primary: true,
      });
    }

    if (UserRoles.getRolePermissionForUser("canDeleteInspections")) {
      options.push({
        name: "Delete Inspection",
        iconClass: "glyphicon glyphicon-trash",
        linkClass: "delete-inspection",
      });
    }

    return options;
  };

  const getActivityActionDropdownOptions = function (canEditActivity, canDeleteActivity) {
    const dropdownOptions = [];

    if (canEditActivity) {
      dropdownOptions.push({
        name: "Edit Activity",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button",
        primary: true,
      });

      dropdownOptions.push({
        name: "Copy",
        iconClass: "glyphicon-duplicate",
        linkClass: "copy-button",
      });
    }

    if (canDeleteActivity && !Session.isFieldPersonnel()) {
      dropdownOptions.push({
        name: "Delete Activity",
        iconClass: "glyphicon-trash",
        linkClass: "delete-button",
      });
    }

    return dropdownOptions;
  };

  const getFacilityActionDropdownOptions = function (
    canInspectFacility,
    canIssueEnforcement,
    canCreateFacility,
    canDeleteFacility,
  ) {
    const optionDropdowns = [
      {
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: canInspectFacility ? false : true,
      },
    ];

    if (canCreateFacility) {
      optionDropdowns.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: true,
      });
    }

    if (canInspectFacility) {
      optionDropdowns.unshift({
        name: "Site Visit",
        analyticsAction: "add_site_visit",
        iconClass: "glyphicon-plus-sign",
        linkClass: "add-facility-inspection",
        primary: true,
      });
    }

    if (canIssueEnforcement) {
      optionDropdowns.unshift({
        name: "Issue Enforcement",
        analyticsAction: "issue_enforcement",
        iconClass: "glyphicon-issue-enforcement",
        linkClass: "issue-facility-enforcement online-only",
      });
    }

    if (canDeleteFacility) {
      optionDropdowns.push({
        name: "Delete Facility",
        analyticsAction: "delete_facility",
        iconClass: "glyphicon-trash",
        linkClass: "delete-facility-button online-only",
      });
    }

    const temp = optionDropdowns[0];
    optionDropdowns[0] = optionDropdowns[1];
    optionDropdowns[1] = temp;
    return optionDropdowns;
  };

  const getIncidentActionDropdownOptions = function (
    canInvestigate,
    canIssueEnforcement,
    canEdit,
    canDelete,
  ) {
    const optionDropdowns = [
      {
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: !canInvestigate,
      },
    ];

    if (canEdit) {
      optionDropdowns.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: true,
      });
    }

    if (canInvestigate) {
      optionDropdowns.unshift({
        name: "Add Investigation",
        analyticsAction: "add_investigation",
        iconClass: "glyphicon-plus-sign",
        linkClass: "new-incident-investigation online-only",
        primary: true,
      });
    }

    if (canIssueEnforcement) {
      optionDropdowns.unshift({
        name: "Issue Enforcement",
        analyticsAction: "issue_enforcement",
        iconClass: "glyphicon-issue-enforcement",
        linkClass: "js-issue-incident-enforcement online-only",
      });
    }

    if (canDelete) {
      optionDropdowns.push({
        name: "Delete Incident",
        analyticsAction: "delete_incident",
        iconClass: "glyphicon-trash",
        linkClass: "js-delete-incident online-only",
      });
    }

    if (optionDropdowns.length >= 2) {
      const temp = optionDropdowns[0];
      optionDropdowns[0] = optionDropdowns[1];
      optionDropdowns[1] = temp;
    }
    return optionDropdowns;
  };

  const getIncidentHistoryActions = function (row, includeUnsubmit = false) {
    const actions = [];

    if (row.noActions) {
      return actions;
    }

    if (row.type === "enforcement") {
      if (row.isMostRecent && !row.resolved) {
        return [
          {
            title: "Review",
            iconClass: row.inProgress ? "glyphicon-pencil" : "glyphicon-issue-enforcement",
            actionClass: "js-edit-incident-enforcement",
            dataId: row.id,
          },
        ];
      }

      const isAdmin = Session.isAdmin();
      return [
        {
          title: isAdmin ? "Edit Enforcement" : "View Enforcement",
          iconClass: isAdmin ? "glyphicon-pencil" : "glyphicon-eye-open",
          actionClass: isAdmin
            ? "js-edit-incident-enforcement black-icon"
            : "js-view-incident-enforcement black-icon",
          dataId: row.id,
        },
      ];
    }

    if (row.locked) {
      actions.push({
        title: "Download investigation report",
        iconClass: "glyphicon-download-alt",
        actionClass: "download-report",
      });
    }
    if (row.editable) {
      actions.push({
        title: "Edit",
        iconClass: "glyphicon-pencil",
        actionClass: "js-edit-assessment",
      });
    } else {
      actions.push({
        title: "View",
        iconClass: "glyphicon-eye-open",
        actionClass: "js-view-assessment",
      });
    }
    if (row.deletable) {
      actions.push({
        title: "Delete",
        iconClass: "glyphicon-trash",
        actionClass: "js-delete-assessment",
      });
    }
    if (includeUnsubmit && row.unsubmittable) {
      actions.push({
        title: "Unsubmit",
        iconClass: "submit-lock-icon unlocked-blue",
        actionClass: "js-unsubmit-record",
      });
    }
    return actions;
  };

  const getIncidentHistoryActionDropdownOptions = function (row) {
    return getIncidentHistoryActions(row, true).map((action, index) => ({
      name: action.title,
      iconClass: `glyphicon ${action.iconClass}`,
      linkClass: action.actionClass,
      primary: index === 0,
    }));
  };

  const getFacilityHistoryActionDropdownOptions = function (historyItem) {
    const options = [];

    if (historyItem.type === "inspection") {
      if (historyItem.displayStatus) {
        if (historyItem.viewable) {
          options.push({
            name: "Download inspection report",
            iconClass: "glyphicon glyphicon-download-alt",
            linkClass: "download-facility-inspection",
            primary: true,
          });
        }
        if (historyItem.editable) {
          options.push({
            name: "Edit inspection",
            iconClass: "glyphicon glyphicon-pencil",
            linkClass: "js-edit-facility-inspection",
            primary: !historyItem.viewable,
          });
        }
        if (historyItem.deletable) {
          options.push({
            name: "Delete Inspection",
            iconClass: "glyphicon-trash",
            linkClass: "js-delete-facility-inspection",
          });
        }
        if (historyItem.canDownloadSignedReport) {
          options.push({
            name: "Download signed report",
            iconClass: "glyphicon glyphicon-download",
            linkClass: "download-signed-report",
            linkAttribute: `data-id='${historyItem.id}'`,
          });
        }
        if (historyItem.unsubmittable) {
          options.push({
            name: "Unsubmit inspection",
            iconClass: "submit-lock-icon unlocked-blue",
            linkClass: "js-unsubmit-record",
            linkAttribute: `data-id='${historyItem.id}'`,
          });
        }
        if (historyItem.canUploadSignedReport) {
          options.push({
            name: "Upload signed report",
            iconClass: "glyphicon glyphicon-upload",
            linkClass: "js-upload-signed-report",
            linkAttribute: `data-id='${historyItem.id}'`,
          });
        }
      }
    } else if (historyItem.type === "enforcement") {
      if ((historyItem.isMostRecent && !historyItem.resolved) || historyItem.inProgress) {
        options.push({
          name: "Review",
          iconClass: historyItem.inProgress
            ? "glyphicon glyphicon-pencil"
            : "glyphicon glyphicon-issue-enforcement",
          linkClass: `js-edit-enforcement`,
          linkAttribute: `data-id='${historyItem.id}'`,
          primary: true,
        });
      } else {
        options.push({
          name: isAdmin() ? "Edit Enforcement" : "View Enforcement",
          iconClass: isAdmin()
            ? "glyphicon glyphicon-pencil black-icon"
            : "glyphicon glyphicon-eye-open black-icon",
          linkClass: isAdmin() ? `js-edit-enforcement` : `js-view-enforcement`,
          linkAttribute: `data-id='${historyItem.id}'`,
          primary: true,
        });
      }
    } else if (historyItem.type === "self-inspection") {
      if (historyItem.hasDownload) {
        options.push({
          name: "Download response",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-facility-self-inspection",
          primary: true,
        });
      }
      if (historyItem.action === "portal-response") {
        options.push({
          name: "View response",
          iconClass: "glyphicon glyphicon-eye-open black-icon",
          linkClass: "js-view-facility-self-inspection",
          primary: !historyItem.hasDownload,
        });
      }
    }

    return options;
  };

  const getCatchBasinDropdownOptions = function (
    id,
    phase,
    permissions,
    showDeleteCatchBasinButton = false,
  ) {
    const props = {};
    const MuniCatchBasinPopup = require("../muni/muniCatchBasinPopup");
    MuniCatchBasinPopup.addInspectionPermissions({ phase, permissions }, props);

    const defaultOptions = [];

    if (Tree.get("dataView") !== "dry-weather") {
      defaultOptions.unshift({
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: permissions.canBeEdited ? false : true,
      });
    }

    if (permissions.canBeEdited) {
      defaultOptions.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary:
          props.displayAddInspectionButton || props.displayDocumentRepairsButton ? false : true,
      });
    }
    if (Tree.get("dataView") === "dry-weather" && props.displayAddInspectionButton) {
      defaultOptions.unshift({
        name: "Dry Weather Screening",
        analyticsAction: "dry_weather_screening",
        primary: true,
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView("catchBasin", id),
      });
    } else if (props.displayAddInspectionButton) {
      defaultOptions.unshift({
        name: "Inspect",
        analyticsAction: "add_site_visit",
        primary: true,
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView("catchBasin", id),
      });
    }

    if (permissions.canBeDeleted && showDeleteCatchBasinButton) {
      defaultOptions.push({
        name: "Delete Catch Basin",
        analyticsAction: "delete_catch_basin",
        iconClass: "glyphicon-trash",
        linkClass: "delete-catch-basin-button online-only",
      });
    }

    return defaultOptions;
  };

  const getStructuralBmpActionDropdownOptions = function (
    permissions,
    idBmp,
    showRoutineMaintenanceButton,
    showAddNewBenchmarkButton,
    showEditBenchmarkButton,
    showAddSbmpAssessmentButton,
    showDeleteSbmpButton = false,
  ) {
    const defaultOptions = [
      {
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: permissions.canBeEdited ? false : true,
      },
    ];

    if (permissions.canBeEdited || UserRoles.getRolePermissionForUser("possibly_edit_bmp")) {
      defaultOptions.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: showAddSbmpAssessmentButton ? false : true,
      });
    }

    if (showAddSbmpAssessmentButton) {
      defaultOptions.unshift({
        name: "Assess",
        analyticsAction: "add_bmp_assessment",
        iconClass: "glyphicon-check",
        linkClass: "add-assessment-button",
        primary: true,
      });
    }

    if (showEditBenchmarkButton) {
      defaultOptions.unshift({
        name: "Benchmark",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-benchmark-button",
      });
    }

    if (showAddNewBenchmarkButton) {
      defaultOptions.unshift({
        name: "Benchmark",
        analyticsAction: "add_new_benchmark",
        iconClass: "glyphicon-check",
        linkClass: "add-benchmark-button",
      });
    }
    if (showRoutineMaintenanceButton) {
      defaultOptions.unshift({
        name: "Inspect",
        analyticsAction: "add_site_visit",
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView("bmpFcs", idBmp),
      });
    }

    if (showDeleteSbmpButton) {
      defaultOptions.push({
        name: "Delete Structural BMP",
        analyticsAction: "delete_sbmp",
        iconClass: "glyphicon-trash",
        linkClass: "delete-sbmp-button online-only",
      });
    }

    return defaultOptions;
  };

  const getSbmpHistoryActionDropdownOptions = function (historyItem, readOnlyTopLevel) {
    const options = [];

    if (historyItem.noActions) {
      return options;
    }

    if (historyItem.assetType === "lid-receive-notice") {
      if (historyItem.hasReport) {
        options.push({
          name: "Download response",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-report",
          primary: true,
        });
      }
      return options;
    }

    if (readOnlyTopLevel || historyItem.readOnly) {
      if (historyItem.hasReport && historyItem.assetType === "bmp") {
        options.push({
          name: "View",
          iconClass: "glyphicon glyphicon-eye-open",
          linkClass: "js-view-assessment",
          primary: true,
        });
        options.push({
          name: "Download assessment report",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-report",
        });
      } else if (
        historyItem.hasReport &&
        (historyItem.assetType === "routineMaintenance" ||
          historyItem.assetType === "routineRepair")
      ) {
        options.push({
          name: "Download inspection report",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-report",
          primary: true,
        });
      } else {
        options.push({
          name: "View",
          iconClass: "glyphicon glyphicon-eye-open",
          linkClass: "js-view-assessment",
          primary: true,
        });
      }
    } else {
      if (historyItem.assessmentType !== "historical") {
        options.push({
          name: "Edit",
          iconClass: "glyphicon glyphicon-pencil",
          linkClass: "js-edit-assessment",
          primary: true,
        });
      }
      if (historyItem.hasReport && historyItem.assetType === "bmp") {
        options.push({
          name: "Download assessment report",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-report",
          primary: historyItem.assessmentType === "historical",
        });
      } else if (
        historyItem.hasReport &&
        (historyItem.assetType === "routineMaintenance" ||
          historyItem.assetType === "routineRepair")
      ) {
        options.push({
          name: "Download assessment report",
          iconClass: "glyphicon glyphicon-download-alt",
          linkClass: "download-report",
          primary: historyItem.assessmentType === "historical",
        });
      }
      options.push({
        name: "Delete",
        iconClass: "glyphicon glyphicon-trash",
        linkClass: "js-delete-assessment",
      });
    }

    return options;
  };

  const getOutfallHistoryActionDropdownOptions = function (historyItem) {
    const options = [];

    if (historyItem.noActions) {
      return options;
    }

    if (historyItem.hasReport) {
      options.push({
        name: "Download assessment report",
        iconClass: "glyphicon glyphicon-download-alt",
        linkClass: "download-report",
        primary: true,
      });
    }

    if (historyItem.permissions?.canCreateOutfallInspection) {
      options.push({
        name: "Edit",
        iconClass: "glyphicon glyphicon-pencil",
        linkClass: "js-edit-assessment",
        primary: !historyItem.hasReport,
      });
    } else {
      options.push({
        name: "View",
        iconClass: "glyphicon glyphicon-eye-open",
        linkClass: "js-view-assessment",
        primary: !historyItem.hasReport,
      });
    }

    if (historyItem.permissions?.canDeleteOutfallInspection) {
      options.push({
        name: "Delete",
        iconClass: "glyphicon glyphicon-trash",
        linkClass: "js-delete-assessment",
      });
    }

    return options;
  };

  const getScenarioDropdownOptions = function (
    id,
    phase,
    canAdvanceProjectPhase,
    canCertifyProject,
    projectPhase,
  ) {
    const defaultOptions = [
      {
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only disabled hide",
      },
    ];
    const props = {};
    let options = defaultOptions;

    addScenarioPlanningPermissions(phase, props);
    if (props.canEdit) {
      options.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: true,
      });
    }

    if (projectPhase) {
      const projectDeliveryActionDropdownOptions =
        getConstructionProjectDeliveryActionDropdownOptions(
          canAdvanceProjectPhase,
          canCertifyProject,
          projectPhase,
        );
      options = options.concat(projectDeliveryActionDropdownOptions);
    }

    return options;
  };

  var addScenarioPlanningPermissions = function (phase, props) {
    const role = ToolSettings.getSetting("permissions", "user_role");
    props.canEdit =
      ["admin", "data-manager"].includes(role) ||
      (role === "planner" && SharedDataFunctions.isBeforePhase(phase, "post-active"));
  };

  const getTrashFcsDropdownOptions = function (permissions, planned, fcsStat) {
    const defaultOptions = [
      {
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: permissions.canBeEdited ? false : true,
      },
    ];

    if (permissions.canBeEdited) {
      defaultOptions.unshift({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: fcsStat && !planned && permissions.canCreateObservation ? false : true,
      });
    }
    if (fcsStat && !planned && permissions.canCreateObservation) {
      defaultOptions.unshift({
        name: "Assess",
        analyticsAction: "add_site_visit",
        iconClass: "glyphicon-check",
        linkClass: "show-fcs-assessment",
        primary: true,
      });
    }

    return defaultOptions;
  };

  const getOutfallDropdownOptions = function (
    id,
    permissions,
    isProjectFactSheet = false,
    showDeleteOutfallButton = false,
  ) {
    const defaultOptions = [];
    const dataView = Tree.get("dataView");
    const isDryWeatherView = dataView === "dry-weather";
    const isWqMonitoringView = dataView === "wq-monitoring" || dataView === "outfalls";

    if (permissions?.canCreateOutfallInspection) {
      if (isDryWeatherView) {
        defaultOptions.push({
          name: "Dry Weather Screening",
          analyticsAction: "dry_weather_screening",
          primary: true,
          iconClass: "glyphicon-plus-sign",
          href: InspectionUrl.getForCurrentView("outfall", id),
        });
      } else if (isWqMonitoringView) {
        defaultOptions.push({
          name: "WQ Monitoring",
          analyticsAction: "wq_monitoring",
          primary: true,
          iconClass: "glyphicon-plus-sign",
          href: InspectionUrl.getForCurrentView("outfall", id),
        });
      } else {
        defaultOptions.push({
          name: "Inspect",
          analyticsAction: "add_site_visit",
          primary: true,
          iconClass: "glyphicon-plus-sign",
          href: InspectionUrl.getForCurrentView("outfall", id),
        });
      }
    }

    if (permissions.canBeEdited) {
      defaultOptions.push({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: isProjectFactSheet
          ? "edit-outfall-button online-only"
          : "edit-button online-only",
        primary: permissions.canCreateOutfallInspection ? false : true,
      });
    }

    if (!isProjectFactSheet && !isDryWeatherView) {
      defaultOptions.push({
        name: "Go to Map",
        analyticsAction: "go_to_map",
        iconClass: "glyphicon-map-marker",
        linkClass: "map-button online-only",
        primary: permissions.canBeEdited ? false : true,
      });
    }

    if (showDeleteOutfallButton) {
      defaultOptions.push({
        name: "Delete Outfall",
        analyticsAction: "delete_outfall",
        iconClass: "glyphicon-trash",
        linkClass: "delete-outfall-button online-only",
      });
    }

    return defaultOptions;
  };

  const getPropertyDropdownOptions = function (id, canCreateBmps, hasBoundary) {
    return [
      {
        name: "Add sBMP",
        primary: true,
        iconClass: "glyphicon-plus",
        linkClass: canCreateBmps && hasBoundary ? "add-sbmp-button" : "disabled",
        href: `#`,
      },
      {
        name: "Edit Property",
        primary: false,
        iconClass: "glyphicon-pencil",
        linkClass: canCreateBmps ? "edit-property-button" : "edit-property-button disabled",
        href: `#`,
      },
      {
        name: "Edit Data Richness",
        primary: false,
        iconClass: "glyphicon-tint",
        linkClass: "update-data-richness-button",
        href: `#`,
      },
      {
        name: "Delete Property",
        primary: false,
        iconClass: "glyphicon-trash",
        linkClass: canCreateBmps ? "delete-property-button" : "disabled",
        href: `#`,
      },
    ];
  };

  const getLidFactSheetDropdownOptions = function (
    canEditProject,
    canDeleteProject,
    canIssueEnforcement,
    showGenerateSummaryButton,
  ) {
    const items = [];

    if (canEditProject) {
      items.push({
        name: "Edit Inventory",
        analyticsAction: "edit_inventory",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-button online-only",
        primary: true,
      });
    }
    _addLidInspectionLetter(showGenerateSummaryButton, items);
    if (canIssueEnforcement) {
      items.push({
        name: "Issue Enforcement",
        analyticsAction: "issue_enforcement",
        iconClass: "glyphicon-issue-enforcement",
        linkClass: "issue-lid-enforcement online-only",
      });
    }
    items.push({
      name: "Go to Map",
      analyticsAction: "go_to_map",
      iconClass: "glyphicon-map-marker",
      linkClass: "map-button online-only",
      primary: canEditProject ? false : true,
    });
    if (FeatureFlag.enabled("download-project-photos")) {
      items.push({
        name: "Download Project Photos",
        analyticsAction: "download_photos",
        iconClass: "glyphicon-download-alt",
        linkClass: "download-button online-only",
      });
    }
    if (canDeleteProject) {
      items.push({
        name: "Delete Project",
        analyticsAction: "delete_project",
        iconClass: "glyphicon-trash",
        linkClass: "delete-button online-only",
      });
    }

    return items;
  };

  const getFactSheetDropdownOptions = function (
    id,
    planId,
    planStatus,
    canCreateBmps,
    hasBoundary = true,
  ) {
    let items = [
      {
        name: "Add sBMP",
        primary: true,
        iconClass: "glyphicon-plus",
        linkClass: "add-sbmp-button",
        href: "#",
      },
      {
        name: "Desktop Analysis",
        primary: true,
        iconClass: "esg-analysis",
        linkClass: hasBoundary ? "action-desktop-analysis" : "disabled",
        href: `#`,
      },
      {
        name: "Edit Property",
        primary: false,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-property-button" + (canCreateBmps ? "" : " disabled"),
        href: `#`,
      },
      {
        name: "Edit Data Richness",
        primary: false,
        iconClass: "glyphicon-tint",
        linkClass: "update-data-richness-button",
        href: `#`,
      },
    ];
    if (planId) {
      items = items.concat(getPlanPropertyDropdownOptions(planId, planStatus, canCreateBmps));
    } else {
      items = items.concat({
        name: "Delete Property",
        primary: false,
        iconClass: "glyphicon-trash",
        linkClass: canCreateBmps ? "delete-property-button" : "disabled",
        href: `#`,
      });
    }
    return items;
  };

  const getPlanDropdownOptions = function (id, phase, wizardCompleted) {
    const availableOptions = [];

    if (phase.toLowerCase() !== "incomplete") {
      availableOptions.push({
        name: "Edit Plan Info",
        primary: true,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-plan-info",
        href: `/impact-accounting/stormwater-plans/edit-info/${id}`,
      });
    }

    if (phase.toLowerCase() === "draft") {
      availableOptions.push({
        name: "Recreate Plan",
        primary: false,
        iconClass: "glyphicon-repeat",
        linkClass: "recreate-plan-button",
        href: `#`,
      });
    }

    if (phase.toLowerCase() === "incomplete") {
      availableOptions.push({
        name: "Finish Creating Plan",
        primary: false,
        iconClass: "glyphicon-pencil",
        linkClass: "finish-creating-plan-button",
        href: `/impact-accounting/stormwater-plans/${id}`,
      });
    }

    if (wizardCompleted) {
      availableOptions.push({
        name: "Change Phase",
        primary: false,
        iconClass: "glyphicon-arrow-right",
        linkClass: "change-phase-button",
        href: "#",
      });
    }

    availableOptions.push({
      name: "Delete Plan",
      primary: false,
      iconClass: "glyphicon-trash",
      linkClass: "delete-plan-button",
      href: `#`,
    });

    return availableOptions;
  };

  const getPlanPropertyDropdownOptions = function (id, currentStatus = "suitable", canCreateBmps) {
    switch (currentStatus) {
      case "selected":
        return [
          {
            name: "Shelve",
            iconClass: "glyphicon-thumbs-down",
            linkClass: canCreateBmps ? "action-shelve-property" : "disabled",
            href: "#",
          },
        ];
      case "shelved":
        return [
          {
            name: "Select",
            primary: true,
            iconClass: "glyphicon-check",
            linkClass: canCreateBmps ? "select-property" : "disabled",
            href: "#",
          },
          {
            name: "Unshelve",
            iconClass: "glyphicon-thumbs-up",
            linkClass: canCreateBmps ? "unshelve-property" : "disabled",
            href: "#",
          },
        ];
      case "suitable":
      default:
        return [
          {
            name: "Select",
            primary: true,
            iconClass: "glyphicon-check",
            linkClass: canCreateBmps ? "select-property" : "disabled",
            href: "#",
          },
          {
            name: "Shelve",
            iconClass: "glyphicon-thumbs-down",
            linkClass: canCreateBmps ? "action-shelve-property" : "disabled",
            href: "#",
          },
        ];
    }
  };

  const getBmpDropdownOptions = function (idBmp, canEdit) {
    const items = [];
    if (canEdit) {
      items.push({
        name: "Inspect",
        primary: true,
        iconClass: "glyphicon-plus-sign",
        href: InspectionUrl.getForCurrentView("bmpFcs", idBmp),
      });
      items.push({
        name: "Edit Inventory",
        primary: false,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-sbmp-button",
        href: "#",
      });
    }
    return items;
  };

  const getContactDropdownOptions = function () {
    return [
      {
        name: "Edit Contact",
        primary: true,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-contact",
        href: "#",
      },
    ];
  };

  const getProjectUserDropdownOptions = function () {
    return [
      {
        name: "Edit User",
        primary: true,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-user",
        href: "#",
      },
    ];
  };

  const getPermitAndPlanDropdownOptions = function (availableForDownload, canEditProject) {
    const options = [];
    if (availableForDownload) {
      options.push({
        name: "Download",
        iconClass: "glyphicon-download-alt",
        linkClass: "download-file",
        href: "#",
        primary: true,
      });
    }
    if (canEditProject) {
      options.push({
        name: "Edit",
        iconClass: "glyphicon-pencil",
        linkClass: "edit-file",
        href: "#",
        primary: !availableForDownload,
      });
    }
    return options;
  };

  const getProjectHistoryDropdownOptions = function (row, readOnlyTopLevel) {
    const tool = Tree.get("tool");
    const options = [];
    if (row.type === "enforcement") {
      if ((row.isMostRecent && !row.resolved) || row.inProgress) {
        options.push({
          name: "Review",
          iconClass: row.inProgress ? "glyphicon-pencil" : "glyphicon-issue-enforcement",
          linkClass: `js-edit-${tool}-enforcement`,
          primary: true,
        });
      } else {
        options.push({
          name: isAdmin() ? "Edit Enforcement" : "View Enforcement",
          iconClass: isAdmin() ? "glyphicon-pencil" : "glyphicon-eye-open",
          linkClass: isAdmin() ? `js-edit-${tool}-enforcement` : `js-view-${tool}-enforcement`,
          primary: true,
        });
      }
    } else if (row.type === "enforcement-action") {
      if (row.viewable) {
        options.push({
          name: "View Enforcement Action",
          iconClass: "glyphicon-eye-open",
          linkClass: "show-enforcement-action",
          primary: true,
        });
      }
      if (row.editable) {
        options.push({
          name: "Edit Enforcement Action",
          iconClass: "glyphicon-pencil",
          linkClass: "show-enforcement-action",
          primary: !row.viewable,
        });
      }
    } else if (row.type === "lid-send-notice" || row.type === "lid-receive-notice") {
      if (row.noActions || row.method === "Field Assessment") {
        return options;
      } else if (
        readOnlyTopLevel ||
        row.action === "send" ||
        row.action === "reminder" ||
        row.method === "Portal"
      ) {
        options.push({
          name: "View",
          iconClass: "glyphicon-eye-open",
          linkClass: "js-view-assessment",
          primary: true,
        });
        if (row.letterFilename) {
          options.push({
            name: "Download letter",
            iconClass: "glyphicon-download-alt",
            linkClass: "download-inspection-report",
          });
        } else if (row.responseFilename) {
          options.push({
            name: "Download response",
            iconClass: "glyphicon-download-alt",
            linkClass: "download-response-report",
          });
        }
        if (row.canDeleteInspection) {
          options.push({
            name: "Delete",
            iconClass: "glyphicon-trash",
            linkClass: "js-delete-assessment",
          });
        }
      } else {
        options.push({
          name: "View",
          iconClass: "glyphicon-eye-open",
          linkClass: "js-view-assessment",
          primary: true,
        });
        if (row.canDeleteInspection) {
          options.push({
            name: "Delete",
            iconClass: "glyphicon-trash",
            linkClass: "js-delete-assessment",
          });
        }
      }
    } else if (row.type === "lid-send-summary") {
      options.push({
        name: "View",
        iconClass: "glyphicon-eye-open",
        linkClass: "js-view-summary",
        primary: true,
      });

      if (row.letterFilename) {
        options.push({
          name: "Download letter",
          iconClass: "glyphicon-download-alt",
          linkClass: "download-summary-report",
        });
      }

      if (row.canDeleteInspection) {
        options.push({
          name: "Delete",
          iconClass: "glyphicon-trash",
          linkClass: "js-delete-summary",
        });
      }
    } else if (row.type === "inspection" || row.type === "installation-inspection") {
      if (row.editable && row.type === "inspection" && tool === "construction") {
        options.push({
          name: "Edit Inspection",
          iconClass: "glyphicon-pencil",
          linkClass: "js-edit-construction-project-inspection",
          primary: true,
        });
      }
      if (row.deletable && row.type === "inspection" && tool === "construction") {
        options.push({
          name: "Delete Inspection",
          iconClass: "glyphicon-trash",
          linkClass: "js-delete-construction-project-inspection",
        });
      }
      if (row.viewable) {
        options.push({
          name: "Download Inspection Report",
          iconClass: "glyphicon-download-alt",
          linkClass: "download-inspection",
          primary: !(row.editable && row.type === "inspection" && tool === "construction"),
        });
      }
      if (row.canDownloadSignedReport) {
        options.push({
          name: "Download Signed Report",
          iconClass: "glyphicon-download",
          linkClass: "download-signed-report",
        });
      }
      if (row.unsubmittable && isAdmin() && tool === "construction") {
        options.push({
          name: "Unsubmit Inspection",
          iconClass: "submit-lock-icon unlocked-blue",
          linkClass: "js-unsubmit-record",
        });
      }
      if (row.canUploadSignedReport && tool === "construction") {
        options.push({
          name: "Upload Signed Report",
          iconClass: "glyphicon-upload",
          linkClass: "js-upload-signed-report",
        });
      }
    } else if (row.assetType === "outfall") {
      if (row.hasReport) {
        options.push({
          name: "Download Inspection Report",
          iconClass: "glyphicon-download-alt",
          linkClass: "download-outfall-inspection-report",
          primary: true,
        });
      }
    } else if (row.idBmp) {
      if (row.noActions) return options;
      if (row.readOnly || readOnlyTopLevel) {
        if (row.assessmentType !== "historical") {
          if (row.hasReport && row.assetType === "bmp") {
            options.push({
              name: "Download Assessment Report",
              iconClass: "glyphicon-download-alt",
              linkClass: "download-bmp-report",
              primary: true,
            });
          } else if (
            row.hasReport &&
            (row.assetType === "routineMaintenance" || row.assetType === "routineRepair")
          ) {
            options.push({
              name: "Download Inspection Report",
              iconClass: "glyphicon-download-alt",
              linkClass: "download-report",
              primary: true,
            });
          } else {
            // @TODO: add this back after fixing https://2ndnature.atlassian.net/browse/SLG-2064
            // options.push({
            //   name: "View",
            //   iconClass: "glyphicon-eye-open",
            //   linkClass: "js-view-bmp-assessment",
            //   primary: true,
            // });
          }
        }
      } else {
        if (row.assessmentType !== "historical") {
          // @TODO: add this back after fixing https://2ndnature.atlassian.net/browse/SLG-2064
          // options.push({
          //   name: "Edit",
          //   iconClass: "glyphicon-pencil",
          //   linkClass: "js-edit-bmp-assessment",
          //   primary: true,
          // });
        }
        if (row.hasReport && row.assetType === "bmp") {
          options.push({
            name: "Download Assessment Report",
            iconClass: "glyphicon-download-alt",
            linkClass: "download-bmp-report",
            primary: true,
          });
        } else if (
          row.hasReport &&
          (row.assetType === "routineMaintenance" || row.assetType === "routineRepair")
        ) {
          options.push({
            name: "Download Inspection Report",
            iconClass: "glyphicon-download-alt",
            linkClass: "download-report",
            primary: true,
          });
        }
        // @TODO: add this back after fixing https://2ndnature.atlassian.net/browse/SLG-2064
        // options.push({
        //   name: "Delete",
        //   iconClass: "glyphicon-trash",
        //   linkClass: "js-delete-bmp-assessment",
        // });
      }
    }

    return options;
  };

  var getUserDropdownOptions = function (id, resend) {
    let items = [
      {
        name: "Edit Permissions",
        primary: true,
        iconClass: "glyphicon-pencil",
        linkClass: "edit-permissions",
        href: "#",
      },
      {
        name: "Remove",
        iconClass: "glyphicon-trash",
        linkClass: "remove-user",
        href: "#",
      },
    ];

    if (resend) {
      items = items.concat([
        {
          name: "Resend Invite",
          iconClass: "mail-send",
          linkClass: "resend-invite",
          href: "#",
        },
      ]);
    }
    return items;
  };

  const getDisplayFieldSetting = function (objectType) {
    return ToolSettings.getSetting("group")["settings"]["displaySettings"][objectType];
  };

  const isPhaseOrLater = function (currentPhase, targetPhase) {
    return SharedDataFunctions.isPhaseOrLater(currentPhase, targetPhase);
  };

  const getDeviceSize = function () {
    const minWidthDesktop = 992;
    const minWidthTablet = 720;
    const screenWidth = window.screen.availWidth;
    if (screenWidth > minWidthDesktop) {
      return "desktop";
    } else if (screenWidth > minWidthTablet) {
      return "tablet";
    } else {
      return "mobile";
    }
  };

  const featureFlagEnabled = function (key) {
    return FeatureFlag.enabled(key);
  };

  const isAdmin = function () {
    return Session.isAdmin();
  };

  const getUserPermission = function (permission) {
    return UserRoles.getConfigForUser(permission);
  };

  var getDisplayFallback = function () {
    return NunjucksFilters.displayFallback;
  };

  var getAssetDisplayName = function (assetName) {
    const displayName = ToolSettings.getSetting("constants", "assetDisplayNames", assetName);

    if (!displayName) {
      throw new Error(`No asset display not found for ${assetName}`);
    }

    return displayName;
  };

  return {
    setupFunctions,
    getCatchBasinDropdownOptions,
    getHardAssetDropdownOptions,
    getHardAssetFactSheetDropdownOptions,
    getHardAssetHistoryActionDropdownOptions,
    getOutfallDropdownOptions,
    getScenarioDropdownOptions,
    getTrashFcsDropdownOptions,
    _getConstructionComplianceActionDropdownOptions,
    getStructuralBmpActionDropdownOptions,
    getSbmpHistoryActionDropdownOptions,
    getOutfallHistoryActionDropdownOptions,
    getConstructionProjectDeliveryActionDropdownOptions,
    getActivityActionDropdownOptions,
    getFacilityActionDropdownOptions,
    getFacilityHistoryActionDropdownOptions,
    getIncidentActionDropdownOptions,
    getIncidentHistoryActions,
    getIncidentHistoryActionDropdownOptions,
    getDisplayFieldSetting,
    getDeviceSize,
    featureFlagEnabled,
  };
};

module.exports = NunjucksFunctions();

const FeatureFlag = require("../settings/featureFlag");
const HardAssetInspectionGate = require("../muni/hardAssetInspectionGate");
const SharedDataFunctions = require("./sharedDataFunctions");
const ToolSettings = require("../settings/toolSettings");
const InspectionUrl = require("../routes/2nform/inspectionUrl");
const Tree = require("../tree");
const Session = require("../login/session");
const UserRoles = require("../login/userRoles");
const UserPermissions = require("../login/userPermissions");
const Progeny = require("../login/progeny");
const NunjucksFilters = require("./nunjucksFilters");
